import { Button, Layout, Space, Tag, theme, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { IoAddSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import routes from "../../../engine/routes";
import { clearUsers, getUsers } from "../Slices/users.slice";
import CustomTable from "../../../shared/components/CustomTable";
import {
  languagesList,
  listRoles,
  renderUserFirstname,
  renderUserGenderShort,
  renderUserLanguagesLong,
  renderUserLastname,
  renderUserName,
  roles,
  subRolesCheckbox,
  userStatusSelect,
} from "../../../utils/constants";
import { BiSearch } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import { formatPhoneDisplay } from "../../../utils/phoneUtils";

const { Content, Sider, Header, Footer } = Layout;

export function UsersList(props) {
  const { users, loading } = useSelector(state => state.users);
  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [search, setSearch] = useState("");
  const [roleSearch, setRoleSearch] = useState([]);
  const [subRoleSearch, setsubRoleSearch] = useState([]);

  useEffect(() => {
    dispatch(getUsers());

    return () => {
      dispatch(clearUsers());
    };
  }, []);

  const handleKeyUp = async event => {
    // Enter
    if (event.keyCode === 13) {
      formRef.current.submit();
    }
  };

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [handleKeyUp]);

  const columns = [
    {
      title: "Nom",
      render: (n, record) => renderUserLastname(record),
      width: "150",
      key: "nom",
      sorter: (a, b) => {
        return a.info.lastname.localeCompare(b.info.lastname);
      },
    },
    {
      title: "Prénom",
      render: (n, record) => renderUserFirstname(record),
      width: "150",
      key: "Prénom",
      sorter: (a, b) => {
        return a.info.firstname.localeCompare(b.info.firstname);
      },
    },
    {
      title: "Institution",
      render: (n, record) => record?.institution?.name,
      key: "Institution",
      width: "100",
      sorter: (a, b) => {
        return a?.institution?.name?.localeCompare(b?.institution?.name);
      },
    },
    {
      title: "Téléphone",
      render: (n, record) => formatPhoneDisplay(record?.info?.phone || ""),
      key: "phone",
      width: "100",
      sorter: (a, b) => {
        return a?.info?.phone?.localeCompare(b?.info?.phone);
      },
    },
    {
      title: "E-mail",
      width: "100",
      dataIndex: "email",
      sorter: (a, b) => {
        return a?.email?.localeCompare(b?.email);
      },
    },
    {
      title: "Accès autorisé",
      width: "50",
      render: (status, u) => {
        return (
          <span>
            {userStatusSelect().find(e => e.value === u.status)?.label}
          </span>
        );
      },
      dataIndex: "status",
      sorter: (a, b) => {
        return a?.status?.localeCompare(b?.status);
      },
    },
    {
      title: "Compte créé",
      render: (status, u) => {
        return <span>{u.accountCreated ? "Oui" : "Non"}</span>;
      },
      width: "50",
      dataIndex: "accountCreated",
      sorter: (a, b) => {
        return a?.accountCreated - b?.accountCreated;
      },
    },
    {
      title: "Rôle",
      key: "role",
      width: "150",
      render: (role, u) => {
        return (
          <Tag color={"lime"}>
            {listRoles.find(e => e.key === u.role)?.label}
          </Tag>
        );
      },
      sorter: (a, b) => {
        return a?.role?.localeCompare(b?.role);
      },
    },
    {
      title: "Sous rôles",
      render: (subRoles, record) => (
        <div>
          {subRolesCheckbox
            ?.filter(e => subRoles?.includes(e.value))
            .map(e => (
              <Tag style={{ margin: 2 }} color={"grey"}>
                {e.label}
              </Tag>
            ))}
        </div>
      ),
      dataIndex: "subRoles",
    },
  ];

  const inputs = [
    {
      parentLabel: null,
      children: [
        {
          label: "Recherche générale",
          placeholder: "Nom, Prénom, Email, Téléphone",
          name: "search",
          value: "",
          type: "input",
          capitalize: false,
          col: 6,
        },
        {
          label: "Filtre par rôle",
          name: "role",
          type: "select",
          value: [],
          showSearch: true,
          allowClear: true,
          reset: true,
          multiple: true,
          selectContent: listRoles,
          col: 6,
        },
        {
          label: "Filtre par sous-rôle (institution)",
          name: "subRoles",
          type: "select",
          value: [],
          showSearch: true,
          allowClear: true,
          reset: true,
          multiple: true,
          selectContent: subRolesCheckbox,
          col: 6,
        },
        {
          type: "component",
          style: { textAlign: "left" },
          col: 3,
          label: "",
          component: () => (
            <>
              <Button
                loading={loading}
                size={"middle"}
                type={"primary"}
                style={{
                  marginTop: "-11px",
                  width: "100%",
                  fontWeight: "bold",
                }}
                icon={<BiSearch style={{ marginTop: "0px" }} size={25} />}
                onClick={() => formRef.current.submit()}
              >
                Rechercher
              </Button>
            </>
          ),
        },
        {
          type: "component",
          col: 3,
          label: "",
          style: { textAlign: "left" },
          component: ({ form }) => (
            <Button
              style={{
                marginTop: "-7px",
                width: "100%",
                color: colorPrimary,
                fontWeight: "bold",
              }}
              icon={<GrPowerReset style={{ marginTop: "-3px" }} size={15} />}
              onClick={async () => {
                setRoleSearch([]);
                setSearch("");
                setsubRoleSearch([]);
                formRef.current.resetFields(); // Reset the form fields using the ref
                form?.resetLocalStorage();

                formRef.current.setFieldsValue({
                  role: undefined,
                  subRoles: undefined,
                  search: "",
                });
              }}
              size="middle"
              type={"text"}
            >
              Réinitialiser
            </Button>
          ),
        },
      ],
    },
  ];

  const onValuesChange = changedValues => {
    Object.keys(changedValues).map(changed => {
      switch (changed) {
        case "search":
          setSearch(changedValues[changed]);
          break;
        case "role":
          setRoleSearch(changedValues[changed]);
          break;
        case "subRoles":
          setsubRoleSearch(changedValues[changed]);
          break;
      }
    });
  };

  const normalizeString = (str = "") =>
    str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const searchFilterData = () =>
    users.filter(user => {
      const {
        info = {},
        email = "",
        userData = {},
        role = "",
        subRoles = [],
      } = user;

      const { firstname = "", lastname = "", phone = "" } = info;

      const normalizedSearch = normalizeString(search);

      const fieldsToCheck = [firstname, lastname, email, phone];

      const hasSearchMatch = fieldsToCheck
        .filter(Boolean)
        .some(field => normalizeString(field).includes(normalizedSearch));

      const roleFilter =
        roleSearch.length > 0 ? roleSearch.includes(role) : true;

      const hasSubRoles =
        subRoleSearch.length === 0 ||
        subRoleSearch.every(subr => subRoles?.includes(subr));

      return (
        hasSubRoles && roleFilter && (search.length === 0 || hasSearchMatch)
      );
    });

  let copy2 = searchFilterData();

  const onSearchForm = data => {
    if (data.search) {
      setSearch(data.search);
    } else {
      setSearch("");
    }

    if (data.role) {
      setRoleSearch(data.role);
    } else {
      setRoleSearch([]);
    }

    if (data.subRoles) {
      setsubRoleSearch(data.subRoles);
    } else {
      setsubRoleSearch([]);
    }
  };

  return (
    <Content>
      <Space
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={2} className={""}>
          Utilisateurs
        </Typography.Title>
      </Space>

      <CustomForm
          saveLocalStorage={true}
          idLocalStorage={"users_list"}
        style={{
          flex: 1,
          maxWidth: 1200,
          paddingRight: 20,
        }}
        dataSource={inputs}
        onKeyUp={handleKeyUp}
        refForm={formRef}
        labelCol={24}
        handleSubmit={onSearchForm}
        wrapperCol={24}
        // onValuesChange={onValuesChange}
      />
      {/*<Link to={routes.users("new").detail.path}>*/}
      {/*  <Button*/}
      {/*    size={"large"}*/}
      {/*    type={"primary"}*/}
      {/*    style={{*/}
      {/*      justifySelf: "flex-start",*/}
      {/*      display: "flex",*/}
      {/*    }}*/}
      {/*    icon={*/}
      {/*      <IoAddSharp*/}
      {/*        style={{*/}
      {/*          marginTop: "0px",*/}
      {/*        }}*/}
      {/*        size={25}*/}
      {/*      />*/}
      {/*    }*/}
      {/*  >*/}
      {/*    {routes.users().new.title}*/}
      {/*  </Button>*/}
      {/*</Link>*/}
      <CustomTable
        loading={loading}
        smTitle={item => {
          return (
            <div className={"alignHeaderPage"}>
              <h2 className={"noMargin"}>{renderUserName(item)}</h2>
            </div>
          );
        }}
        onRowLink={record => {
          if (record.role === roles.institution) {
            return routes
              .institutions(record.institution._id)
              .detailUser(record._id).path;
          }

          if (record.role === roles.interprete) {
            return routes.interpretes(record._id).detail.path;
          }

          if (record.role === roles.admin || record.role === roles.permanance) {
            return routes.users(record._id).detail.path;
          }
        }}
        hasPagination={false}
        pagination={{
          hideOnSinglePage: true,
          position: ["topRight"],
          defaultPageSize: 100,
          pageSizeOptions: [10, 20, 50, 100, 250, 500],
          showSizeChanger: true,
        }}
        dataSource={copy2}
        columns={columns}
        rowKey="_id"
      />
    </Content>
  );
}
